export interface StorySectionDto {
  text: string;
  options: OptionDto[];
}

export interface OptionDto {
  key: number;
  text: string;
}

export interface ErrorDto {
  type: number;
  message: string;
}

export interface UserStatsDto {
  canGenerateMore: boolean;
}

export interface StoryDto {
  id: string;
  title: string;
  summary: string;
  sections: StorySectionDto[];
}

export class ErrorTypes {
  public static Generic = 500;
  public static TokenLimitReached = 402;
  public static AlreadyGenerating = 409;
  public static NotFound = 404;
}
